import {
  type PaginatedMaintenanceStrategy,
  type PaginatedTransformedMaintenanceStrategy,
} from "@/api/resources/maintenanceStrategies/types";
import {
  getMaintenanceStrategyTriggerType,
  readableMaintenanceStrategyTrigger,
} from "@/api/resources/maintenanceStrategyTriggers/utils";
import { filterNotEmpty } from "@/utils/format";
import { nextRRuleOccasion, readableRRule } from "@/utils/rrule";

export const transformPaginatedMaintenanceStrategies = (
  _maintenanceStrategies: PaginatedMaintenanceStrategy[],
): PaginatedTransformedMaintenanceStrategy[] => {
  return _maintenanceStrategies.filter(filterNotEmpty).map((strategy) => {
    const planned_devices_count = strategy.maintenance_strategies_to_devices.length || 0;

    const intervals = strategy.maintenance_strategy_intervals;
    const interval = intervals.length > 0 ? intervals[0] : undefined;
    const interval_human = interval ? readableRRule(interval.schedule_interval) : null;
    const next_date = interval ? nextRRuleOccasion(interval.schedule_interval) : null;

    const triggers = strategy.maintenance_strategy_triggers;
    const trigger = triggers.length > 0 ? triggers[0] : undefined;
    const trigger_human = trigger ? readableMaintenanceStrategyTrigger(trigger) : null;

    const type = getMaintenanceStrategyTriggerType({ interval, trigger });

    return {
      ...strategy,
      trigger,
      interval,
      trigger_human,
      interval_human,
      next_date,
      planned_devices_count,
      type,
    };
  });
};
